"use client";

import { useEffect } from "react";
import { trackClientEvent } from "@/lib/tracking/client";

export function TrackOnMount({ tool }: { tool: string }) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const key = `tracked_tool_opened_${tool}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // sessionStorage unavailable — still track, just skip dedup
    }
    trackClientEvent("tool_opened", { tool });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
